(() => {
  const fomoEvents = [
    { display_name: 'thaynaraceli', product: 'Stick Balm Petfleur 50 g', source: 'Shopee', source_identifier: 'shopee:459875657:70371581804454', identity_type: 'PUBLIC_NICKNAME', verified_relation: true, safe_for_public_display: true },
    { display_name: 'louisebduarte', product: 'Stick Balm Petfleur 50 g', source: 'Shopee', source_identifier: 'shopee:459875657:70371554121992', identity_type: 'PUBLIC_NICKNAME', verified_relation: true, safe_for_public_display: true },
    { display_name: 'danialvestupa', product: 'Stick Balm Petfleur 50 g', source: 'Shopee', source_identifier: 'shopee:459875657:70371402589336', identity_type: 'PUBLIC_NICKNAME', verified_relation: true, safe_for_public_display: true },
    { display_name: '6cyby6l3g3', product: 'Stick Balm Petfleur 50 g', source: 'Shopee', source_identifier: 'shopee:459875657:70371169715090', identity_type: 'PUBLIC_NICKNAME', verified_relation: true, safe_for_public_display: true },
    { display_name: 'b.for', product: 'Stick Balm Petfleur 50 g', source: 'Shopee', source_identifier: 'shopee:459875657:70371076500211', identity_type: 'PUBLIC_NICKNAME', verified_relation: true, safe_for_public_display: true },
    { display_name: 'criscastelo3', product: 'Desinfetante BacfreeVet Floral Petfleur 1 L', source: 'Shopee', source_identifier: 'shopee:459875657:70371752438738', identity_type: 'PUBLIC_NICKNAME', verified_relation: true, safe_for_public_display: true },
    { display_name: 'lis2113', product: 'Desinfetante BacfreeVet Floral Petfleur 1 L', source: 'Shopee', source_identifier: 'shopee:459875657:70371746409238', identity_type: 'PUBLIC_NICKNAME', verified_relation: true, safe_for_public_display: true },
    { display_name: 'gugaana12', product: 'Desinfetante BacfreeVet Floral Petfleur 1 L', source: 'Shopee', source_identifier: 'shopee:459875657:70371728175505', identity_type: 'PUBLIC_NICKNAME', verified_relation: true, safe_for_public_display: true },
    { display_name: 'deniseademir', product: 'Desinfetante BacfreeVet Floral Petfleur 1 L', source: 'Shopee', source_identifier: 'shopee:459875657:70371580684876', identity_type: 'PUBLIC_NICKNAME', verified_relation: true, safe_for_public_display: true },
    { display_name: 'leandraszewczynski', product: 'Desinfetante BacfreeVet Floral Petfleur 1 L', source: 'Shopee', source_identifier: 'shopee:459875657:70371538825284', identity_type: 'PUBLIC_NICKNAME', verified_relation: true, safe_for_public_display: true },
    { display_name: 'artesfocinhos', product: 'Gel Dental OralPet Menta Petfleur 100 ml', source: 'Shopee', source_identifier: 'shopee:459875657:70370725213718', identity_type: 'PUBLIC_NICKNAME', verified_relation: true, safe_for_public_display: true },
    { display_name: 'kahju', product: 'Gel Dental OralPet Menta Petfleur 100 ml', source: 'Shopee', source_identifier: 'shopee:459875657:70370671215950', identity_type: 'PUBLIC_NICKNAME', verified_relation: true, safe_for_public_display: true },
    { display_name: 'isabelymiwa', product: 'Gel Dental OralPet Menta Petfleur 100 ml', source: 'Shopee', source_identifier: 'shopee:459875657:70369990244711', identity_type: 'PUBLIC_NICKNAME', verified_relation: true, safe_for_public_display: true },
    { display_name: 'adrianadacosta375', product: 'Gel Dental OralPet Menta Petfleur 100 ml', source: 'Shopee', source_identifier: 'shopee:459875657:70369843114557', identity_type: 'PUBLIC_NICKNAME', verified_relation: true, safe_for_public_display: true },
    { display_name: 'mcsnmaju', product: 'Gel Dental OralPet Menta Petfleur 100 ml', source: 'Shopee', source_identifier: 'shopee:459875657:70369800390154', identity_type: 'PUBLIC_NICKNAME', verified_relation: true, safe_for_public_display: true },
    { display_name: 'elisa22s', product: 'Shampoo Melaleuca Petfleur 240 ml', source: 'Shopee', source_identifier: 'shopee:459875657:70371047398607', identity_type: 'PUBLIC_NICKNAME', verified_relation: true, safe_for_public_display: true },
    { display_name: 'kaberbert_78', product: 'Shampoo Melaleuca Petfleur 240 ml', source: 'Shopee', source_identifier: 'shopee:459875657:70371007795804', identity_type: 'PUBLIC_NICKNAME', verified_relation: true, safe_for_public_display: true },
    { display_name: 'yarabarreto369', product: 'Shampoo Melaleuca Petfleur 240 ml', source: 'Shopee', source_identifier: 'shopee:459875657:70371004320157', identity_type: 'PUBLIC_NICKNAME', verified_relation: true, safe_for_public_display: true },
    { display_name: 'jotape_d3', product: 'Shampoo Melaleuca Petfleur 240 ml', source: 'Shopee', source_identifier: 'shopee:459875657:70370969741973', identity_type: 'PUBLIC_NICKNAME', verified_relation: true, safe_for_public_display: true },
    { display_name: 'ghiovana.martins', product: 'Shampoo Melaleuca Petfleur 240 ml', source: 'Shopee', source_identifier: 'shopee:459875657:70370920632272', identity_type: 'PUBLIC_NICKNAME', verified_relation: true, safe_for_public_display: true },
    { display_name: 'marinarocha354', product: 'Espuma Limpa Patas com Escova', source: 'Shopee', source_identifier: 'shopee:459875657:70371747999850', identity_type: 'PUBLIC_NICKNAME', verified_relation: true, safe_for_public_display: true },
    { display_name: 'camilabezerra745', product: 'Espuma Limpa Patas com Escova', source: 'Shopee', source_identifier: 'shopee:459875657:70371718028611', identity_type: 'PUBLIC_NICKNAME', verified_relation: true, safe_for_public_display: true },
    { display_name: 'elainecllourenco', product: 'Espuma Limpa Patas com Escova', source: 'Shopee', source_identifier: 'shopee:459875657:70371691988774', identity_type: 'PUBLIC_NICKNAME', verified_relation: true, safe_for_public_display: true },
    { display_name: 'camilacristina32', product: 'Espuma Limpa Patas com Escova', source: 'Shopee', source_identifier: 'shopee:459875657:70371688826876', identity_type: 'PUBLIC_NICKNAME', verified_relation: true, safe_for_public_display: true },
    { display_name: 'jenniferabrgs', product: 'Espuma Limpa Patas com Escova', source: 'Shopee', source_identifier: 'shopee:459875657:70371685129810', identity_type: 'PUBLIC_NICKNAME', verified_relation: true, safe_for_public_display: true }
  ];
  const pushEvent = (event, detail = {}) => {
    if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event, ...detail });
    document.dispatchEvent(new CustomEvent('petfleur:conversion', { detail: { event, ...detail } }));
  };

  const initPrivacy = () => {
    const banner = document.querySelector('[data-cookie-consent]');
    const dialog = document.querySelector('[data-cookie-dialog]');
    if (!banner || !dialog) return;

    const analytics = dialog.querySelector('[data-cookie-analytics]');
    const marketing = dialog.querySelector('[data-cookie-marketing]');
    const saveButton = dialog.querySelector('[data-cookie-save]');
    const status = document.querySelector('[data-cookie-status]');
    const actionButtons = [...document.querySelectorAll('[data-cookie-accept], [data-cookie-reject], [data-cookie-save]')];
    let privacy = window.Shopify && window.Shopify.customerPrivacy ? window.Shopify.customerPrivacy : null;
    let loadingPrivacy = null;

    const params = new URLSearchParams(window.location.search);
    const isThemePreview = Boolean(
      (window.Shopify && window.Shopify.designMode) ||
      params.has('preview_theme_id') ||
      params.has('_ab') ||
      window.location.hostname.includes('shopifypreview.com')
    );

    const previewStorageKey = 'petfleur_cookie_preview_choice_v1';

    const setBanner = (visible) => {
      banner.hidden = !visible;
      banner.setAttribute('aria-hidden', String(!visible));
    };

    const setStatus = (message = '', isError = false) => {
      if (!status) return;
      status.textContent = message;
      status.hidden = !message;
      status.classList.toggle('is-error', Boolean(isError));
    };

    const setBusy = (busy) => {
      actionButtons.forEach((button) => {
        button.disabled = busy;
        button.setAttribute('aria-busy', String(busy));
      });
    };

    const closeDialog = () => {
      if (dialog.open && typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    };

    const closeUi = () => {
      setStatus('');
      setBusy(false);
      setBanner(false);
      closeDialog();
    };

    const ensurePrivacy = () => {
      if (privacy && typeof privacy.setTrackingConsent === 'function') return Promise.resolve(privacy);
      if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
        privacy = window.Shopify.customerPrivacy;
        return Promise.resolve(privacy);
      }
      if (loadingPrivacy) return loadingPrivacy;

      loadingPrivacy = new Promise((resolve) => {
        if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
          resolve(null);
          return;
        }

        let settled = false;
        const finish = (value) => {
          if (settled) return;
          settled = true;
          if (value) privacy = value;
          resolve(value || null);
        };

        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.2' }],
          (error) => {
            if (error) {
              finish(null);
              return;
            }
            finish(window.Shopify && window.Shopify.customerPrivacy ? window.Shopify.customerPrivacy : null);
          }
        );

        window.setTimeout(() => {
          finish(window.Shopify && window.Shopify.customerPrivacy ? window.Shopify.customerPrivacy : null);
        }, 2500);
      }).finally(() => {
        loadingPrivacy = null;
      });

      return loadingPrivacy;
    };

    const readConsent = () => {
      if (!privacy || typeof privacy.currentVisitorConsent !== 'function') return null;
      try {
        return privacy.currentVisitorConsent();
      } catch (error) {
        return null;
      }
    };

    const readPreviewConsent = () => {
      if (!isThemePreview) return null;
      try {
        const stored = window.localStorage.getItem(previewStorageKey);
        return stored ? JSON.parse(stored) : null;
      } catch (error) {
        return null;
      }
    };

    const writePreviewConsent = (consent) => {
      if (!isThemePreview) return false;
      try {
        window.localStorage.setItem(previewStorageKey, JSON.stringify(consent));
        return true;
      } catch (error) {
        return false;
      }
    };

    const syncPreferenceControls = () => {
      const current = readConsent();
      if (current) {
        analytics.checked = current.analytics === 'yes';
        marketing.checked = current.marketing === 'yes';
        return;
      }

      const previewConsent = readPreviewConsent();
      if (previewConsent) {
        analytics.checked = Boolean(previewConsent.analytics);
        marketing.checked = Boolean(previewConsent.marketing);
      }
    };

    const openPreferences = async () => {
      await ensurePrivacy();
      syncPreferenceControls();
      setStatus('');
      if (typeof dialog.showModal === 'function') {
        if (!dialog.open) dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    };

    const consentMatches = (expected) => {
      const current = readConsent();
      if (!current) return false;
      const expectedValue = (value) => value ? 'yes' : 'no';
      return (
        current.analytics === expectedValue(Boolean(expected.analytics)) &&
        current.marketing === expectedValue(Boolean(expected.marketing)) &&
        current.preferences === expectedValue(Boolean(expected.preferences))
      );
    };

    const writeConsent = (api, consent) => new Promise((resolve) => {
      let finished = false;
      let verifyTimer;

      const finish = (ok) => {
        if (finished) return;
        finished = true;
        if (verifyTimer) window.clearInterval(verifyTimer);
        resolve(Boolean(ok));
      };

      try {
        api.setTrackingConsent(consent, () => {
          privacy = api;
          finish(true);
        });

        let attempts = 0;
        verifyTimer = window.setInterval(() => {
          attempts += 1;
          privacy = api;
          if (consentMatches(consent)) finish(true);
          else if (attempts >= 20) finish(false);
        }, 150);
      } catch (error) {
        finish(false);
      }
    });

    const save = async (consent) => {
      setBusy(true);
      setStatus('Salvando sua preferência…');

      const api = await ensurePrivacy();

      if (!api || typeof api.setTrackingConsent !== 'function') {
        if (writePreviewConsent(consent)) {
          closeUi();
          return;
        }

        setBusy(false);
        setStatus('Não foi possível acessar o controle de privacidade da Shopify. Recarregue a página e tente novamente.', true);
        return;
      }

      const saved = await writeConsent(api, consent);
      if (!saved) {
        if (writePreviewConsent(consent)) {
          closeUi();
          return;
        }

        setBusy(false);
        setStatus('A Shopify não confirmou a gravação da preferência. Tente novamente.', true);
        return;
      }

      closeUi();
    };

    document.querySelectorAll('[data-cookie-preferences]').forEach((button) => {
      button.addEventListener('click', openPreferences);
    });

    document.querySelectorAll('[data-cookie-accept]').forEach((button) => {
      button.addEventListener('click', () => save({ analytics: true, marketing: true, preferences: true }));
    });

    document.querySelectorAll('[data-cookie-reject]').forEach((button) => {
      button.addEventListener('click', () => save({ analytics: false, marketing: false, preferences: false }));
    });

    if (saveButton) {
      saveButton.addEventListener('click', () => save({
        analytics: analytics.checked,
        marketing: marketing.checked,
        preferences: true
      }));
    }

    ensurePrivacy().then((api) => {
      if (!api) {
        if (isThemePreview) {
          syncPreferenceControls();
          setBanner(true);
        } else {
          setBanner(false);
        }
        return;
      }

      privacy = api;
      syncPreferenceControls();

      const current = readConsent();
      const hasDecision = Boolean(
        current &&
        [current.analytics, current.marketing, current.preferences].some((value) => value === 'yes' || value === 'no')
      );
      const shouldShow = typeof privacy.shouldShowBanner === 'function' ? privacy.shouldShowBanner() : !hasDecision;
      setBanner(Boolean(shouldShow && !hasDecision));
    });

    document.addEventListener('visitorConsentCollected', () => {
      syncPreferenceControls();
      closeUi();
    });
  };
  const initSocialProof = () => {
    const root = document.querySelector('[data-social-proof]');
    if (!root) return;

    const nameNode = root.querySelector('[data-fomo-name]');
    const productNode = root.querySelector('[data-fomo-product]');
    if (!nameNode || !productNode) return;

    const events = fomoEvents.filter((item) => item.verified_relation === true && item.safe_for_public_display === true);
    if (!events.length) return;

    for (let i = events.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [events[i], events[j]] = [events[j], events[i]];
    }

    let index = 0;
    const updateContent = () => {
      const item = events[index];
      nameNode.textContent = item.display_name;
      productNode.textContent = item.product;
      index = (index + 1) % events.length;
    };

    updateContent();

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    window.setInterval(() => {
      root.classList.add('is-changing');
      window.setTimeout(() => {
        updateContent();
        root.classList.remove('is-changing');
      }, 240);
    }, 6500);
  };
  const initReviewHighlights = () => {
    const roots = document.querySelectorAll('[data-review-highlights]');
    if (!roots.length) return;
    const render = () => {
      const source = document.querySelector('#petfleur-judge-me');
      const reviews = source ? [...source.querySelectorAll('.jdgm-rev')].slice(0, 6) : [];
      if (!reviews.length) return false;
      roots.forEach((root) => {
        if (root.dataset.ready === 'true') return;
        const viewport = root.querySelector('[data-review-viewport]');
        const sourceReviews = reviews.filter((review) => review.querySelector('.jdgm-rev__body'));
        if (!sourceReviews.length) return;
        viewport.innerHTML = sourceReviews.map((review) => {
          const rating = review.getAttribute('data-rating') || review.querySelector('[data-rating]')?.getAttribute('data-rating') || '5';
          return `<article class="petfleur-review-highlights__card"><p><a class="petfleur-review-highlights__stars petfleur-rating-link" href="#petfleur-judge-me" aria-label="${rating} de 5 estrelas. Ver todas as avaliações">${'★'.repeat(Math.max(1, Math.min(5, Number(rating) || 5)))}</a></p><p class="petfleur-review-highlights__text"></p><p class="petfleur-review-highlights__author"></p></article>`;
        }).join('');
        [...viewport.querySelectorAll('.petfleur-review-highlights__card')].forEach((card, index) => {
          const review = sourceReviews[index];
          card.querySelector('.petfleur-review-highlights__text').textContent = review.querySelector('.jdgm-rev__body').textContent.trim();
          card.querySelector('.petfleur-review-highlights__author').textContent = review.querySelector('.jdgm-rev__author')?.textContent.trim() || 'Cliente Petfleur';
        });
        root.querySelector('[data-review-previous]').addEventListener('click', () => { viewport.scrollBy({ left: -viewport.clientWidth, behavior: 'smooth' }); pushEvent('review_carousel_interaction', { action: 'previous' }); });
        root.querySelector('[data-review-next]').addEventListener('click', () => { viewport.scrollBy({ left: viewport.clientWidth, behavior: 'smooth' }); pushEvent('review_carousel_interaction', { action: 'next' }); });
        root.querySelector('[data-review-scroll]').addEventListener('click', () => pushEvent('review_scroll'));
        root.dataset.ready = 'true';
        root.hidden = false;
      });
      return true;
    };
    if (render()) return;
    const observer = new MutationObserver(() => { if (render()) observer.disconnect(); });
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 12000);
  };

  const initJudgeMeMedia = () => {
    const root = document.querySelector('#petfleur-judge-me');
    if (!root) return;

    const hydrate = () => {
      root.querySelectorAll('.jdgm-rev__pic-img[data-src], .jdgm-gallery img[data-src]').forEach((img) => {
        const source = img.getAttribute('data-src');
        if (!source || img.getAttribute('src')) return;

        const link = img.closest('.jdgm-rev__pic-link');
        const clearLoading = () => {
          if (link) link.classList.remove('jdgm--loading');
        };

        img.addEventListener('load', clearLoading, { once: true });
        img.addEventListener('error', clearLoading, { once: true });
        img.loading = 'lazy';
        img.decoding = 'async';
        img.setAttribute('src', source);
      });
    };

    hydrate();

    const observer = new MutationObserver(() => hydrate());
    observer.observe(root, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', hydrate);
  };


  const initReviewPresentation = () => {
    const reviewRoot = document.querySelector('#petfleur-judge-me');
    const internalLabels = new Set([
      'origem',
      'anuncio shopee',
      'anúncio shopee',
      'chave da avaliacao',
      'chave da avaliação',
      'source review id'
    ]);

    const cleanLabel = (value = '') => value
      .replace(/:/g, '')
      .trim()
      .toLocaleLowerCase('pt-BR');

    const hideInternalMetadata = () => {
      if (!reviewRoot) return;

      const normalize = (value = '') => String(value)
        .replace(/:/g, '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLocaleLowerCase('pt-BR');

      const shouldHideLabel = (value = '') => internalLabels.has(normalize(value));

      const hideElement = (element) => {
        if (!element || element === reviewRoot) return;
        if (element.matches('.jdgm-rev, [data-review-id], [class*="review-card"], [class*="review_card"]')) return;
        element.classList.add('petfleur-review-meta-hidden');
        element.setAttribute('data-petfleur-review-meta-hidden', 'true');
        element.setAttribute('aria-hidden', 'true');
      };

      reviewRoot.querySelectorAll('.jdgm-rev__cf-ans, [class*="cf-ans"], [class*="custom-field"], [class*="custom_field"], [data-question-title]').forEach((row) => {
        const candidate =
          row.getAttribute('data-question-title') ||
          row.querySelector('.jdgm-rev__cf-ans__title, [class*="title"], [data-question-title]')?.textContent ||
          '';
        if (shouldHideLabel(candidate)) hideElement(row);
      });

      const walker = document.createTreeWalker(reviewRoot, NodeFilter.SHOW_TEXT);
      const matches = [];
      let node;
      while ((node = walker.nextNode())) {
        if (shouldHideLabel(node.nodeValue)) matches.push(node);
      }

      matches.forEach((textNode) => {
        const labelElement = textNode.parentElement;
        if (!labelElement) return;

        let candidate = labelElement;
        let best = labelElement;
        for (let depth = 0; depth < 4 && candidate && candidate !== reviewRoot; depth += 1) {
          const content = normalize(candidate.textContent);
          const isWholeReview = candidate.matches?.('.jdgm-rev, [data-review-id], [class*="review-card"], [class*="review_card"]');
          if (isWholeReview) break;

          if (content.length > 0 && content.length <= 500) {
            best = candidate;
            if (content.length > normalize(textNode.nodeValue).length) break;
          }
          candidate = candidate.parentElement;
        }

        hideElement(best);
      });

      reviewRoot.querySelectorAll('.jdgm-rev__custom-form, [class*="custom-form"], [class*="custom_form"]').forEach((form) => {
        const visibleText = normalize(
          [...form.children]
            .filter((child) => !child.classList.contains('petfleur-review-meta-hidden'))
            .map((child) => child.textContent)
            .join(' ')
        );
        if (!visibleText) hideElement(form);
      });
    };

    const linkProductRatingStars = () => {
      document.querySelectorAll('.petfleur-product-rating .jdgm-prev-badge__stars').forEach((stars) => {
        if (stars.closest('a.petfleur-rating-link')) return;

        const link = document.createElement('a');
        link.className = 'petfleur-rating-link';
        link.href = '#petfleur-judge-me';
        link.setAttribute('aria-label', 'Ver todas as avaliações deste produto');
        stars.parentNode.insertBefore(link, stars);
        link.appendChild(stars);
      });
    };

    hideInternalMetadata();
    linkProductRatingStars();

    if (reviewRoot) {
      const observer = new MutationObserver(() => hideInternalMetadata());
      observer.observe(reviewRoot, { childList: true, subtree: true });
    }

    window.setTimeout(linkProductRatingStars, 500);
    window.setTimeout(linkProductRatingStars, 1500);
    window.setTimeout(linkProductRatingStars, 3000);
    document.addEventListener('shopify:section:load', () => {
      hideInternalMetadata();
      linkProductRatingStars();
    });
  };

  const initJudgeMeTranslations = () => {
    const judgeMeText = {
      widget_title: 'Avaliações de clientes',
      widget_open_form_text: 'Escrever uma avaliação',
      widget_close_form_text: 'Cancelar avaliação',
      widget_review_body_field_text: 'Conteúdo da avaliação',
      widget_review_body_placeholder_text: 'Comece a escrever aqui...',
      widget_rating_field_text: 'Avaliação',
      widget_submit_review_text: 'Enviar avaliação',
      widget_submit_verified_review_text: 'Enviar avaliação verificada',
      widget_back_button_text: 'Voltar',
      widget_next_button_text: 'Próximo',
      review_content_screen_title_text: 'Como você avalia este produto?',
      review_content_introduction_text: 'Conte um pouco sobre a sua experiência com este produto.',
      one_star_review_guidance_text: 'Ruim',
      five_star_review_guidance_text: 'Excelente',
      custom_questions_screen_title_text: 'Conte mais sobre sua experiência',
      custom_questions_introduction_text: 'Responda às perguntas abaixo para nos ajudar a entender melhor sua experiência.',
      review_submitted_screen_title_text: 'Obrigado pela sua avaliação!',
      review_submitted_screen_thank_you_text: 'Estamos processando sua avaliação e ela aparecerá na loja em breve.',
      review_submitted_screen_email_verification_text: 'Confirme seu e-mail pelo link que enviamos. Isso nos ajuda a manter avaliações autênticas.',
      write_review_flow_privacy_message_text: 'Respeitamos sua privacidade.',
      write_review_flow_gdpr_statement: "Só entraremos em contato sobre sua avaliação se necessário. Ao enviar sua avaliação, você concorda com nossos <a href='https://judge.me/terms' target='_blank' rel='nofollow noopener'>termos e condições</a> e com nossa <a href='https://judge.me/privacy' target='_blank' rel='nofollow noopener'>política de privacidade</a>."
    };

    const applyJudgeMeSettings = () => {
      if (!window.jdgmSettings || typeof window.jdgmSettings !== 'object') return false;
      Object.assign(window.jdgmSettings, judgeMeText);
      window.jdgmSettings.locale = 'pt';
      window.jdgmSettings.shop_locale = 'pt';
      return true;
    };

    const translations = new Map([
      ['write a review', 'Escrever uma avaliação'],
      ['customer reviews', 'Avaliações de clientes'],
      ['poor', 'Ruim'],
      ['great', 'Excelente'],
      ['review content', 'Conteúdo da avaliação'],
      ['review content (required)', 'Conteúdo da avaliação (obrigatório)'],
      ['start writing here...', 'Comece a escrever aqui...'],
      ['back', 'Voltar'],
      ['next', 'Próximo'],
      ['how would you rate this product?', 'Como você avalia este produto?'],
      ['we would love it if you would share a bit about your experience.', 'Conte um pouco sobre a sua experiência com este produto.']
    ]);

    const translateText = (root = document) => {
      if (!root || typeof root.querySelectorAll !== 'function') return;

      root.querySelectorAll('button, a, span, div, p, small, strong, label').forEach((element) => {
        if (element.children.length > 0) return;
        const raw = (element.textContent || '').replace(/\s+/g, ' ').trim();
        const translated = translations.get(raw.toLowerCase());
        if (!translated) return;
        element.textContent = translated;
      });

      root.querySelectorAll('[placeholder]').forEach((element) => {
        const raw = (element.getAttribute('placeholder') || '').replace(/\s+/g, ' ').trim();
        const translated = translations.get(raw.toLowerCase());
        if (translated) element.setAttribute('placeholder', translated);
      });

      root.querySelectorAll('[aria-label]').forEach((element) => {
        const raw = (element.getAttribute('aria-label') || '').replace(/\s+/g, ' ').trim();
        const translated = translations.get(raw.toLowerCase());
        if (translated) element.setAttribute('aria-label', translated);
      });
    };

    applyJudgeMeSettings();
    translateText();

    const observer = new MutationObserver(() => {
      applyJudgeMeSettings();
      translateText();
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });

    window.setTimeout(() => { applyJudgeMeSettings(); translateText(); }, 250);
    window.setTimeout(() => { applyJudgeMeSettings(); translateText(); }, 750);
    window.setTimeout(() => { applyJudgeMeSettings(); translateText(); }, 1500);
    window.setTimeout(() => { applyJudgeMeSettings(); translateText(); }, 3000);

    document.addEventListener('shopify:section:load', () => {
      applyJudgeMeSettings();
      translateText();
    });
  };

  const initRatingLabels = () => {
    const decorate = () => {
      document.querySelectorAll('.petfleur-product-rating .jdgm-prev-badge').forEach((badge) => {
        const root = badge.closest('.petfleur-product-rating');
        const average = Number(badge.dataset.averageRating || 0);
        const count = Number(badge.dataset.numberOfReviews || 0);
        if (!root) return;

        const shouldShow = Boolean(average && count);
        if (root.hidden === shouldShow) root.hidden = !shouldShow;
        if (!shouldShow) return;

        let summary = root.querySelector('.petfleur-rating__summary');
        if (!summary) {
          summary = document.createElement('span');
          summary.className = 'petfleur-rating__summary';
          badge.insertAdjacentElement('afterend', summary);
        }

        const nextText = `${average.toFixed(2).replace('.', ',')} (${count})`;
        if (summary.textContent !== nextText) summary.textContent = nextText;
      });
    };

    decorate();
    window.setTimeout(decorate, 500);
    window.setTimeout(decorate, 1500);
    window.setTimeout(decorate, 3000);

    document.addEventListener('shopify:section:load', decorate);
  };

  const initTracking = () => {
    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-buy-now]')) pushEvent('buy_now_click');
      const cartCheckout = event.target.closest('[data-cart-checkout]');
      if (cartCheckout) pushEvent('cart_checkout_click', { cart_total_cents: Number(cartCheckout.dataset.cartTotal || 0) });
      if (event.target.closest('[data-policy-delivery]')) pushEvent('policy_delivery_click');
      if (event.target.closest('[data-policy-returns]')) pushEvent('policy_returns_click');
    });
    document.addEventListener('submit', (event) => {
      if (event.target.matches('[data-product-form]')) pushEvent('quick_add');
    });
  };

  const init = () => { initPrivacy(); initSocialProof(); initReviewHighlights(); initJudgeMeMedia(); initReviewPresentation(); initJudgeMeTranslations(); initRatingLabels(); initTracking(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
